// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getPipTypes} from '../../shared/repositories';

export const readFacetsData = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const pipTypes = await getPipTypes();

            dispatch({
                data: pipTypes,
                type: actions.READ_PIP_SEARCH_PIP_TYPES_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/pip-search/action-creators/read-facets-data.js